import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let id = useDataValue({
    context: 'payment_plan',
    path: 'request_id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      id,
    },
  }
}
